import { NavLink, useLocation } from 'react-router-dom'
import cn from 'classnames'

import { ChartIcon, HomeIcon, StepTooltip, UserIcon } from 'components'
import { analyticsContext } from 'contexts'

export const NavBar = () => {
  const onUserClick = () => analyticsContext.trackEvent('account_opened')
  const onChartClick = () => analyticsContext.trackEvent('graph_opened')

  const location = useLocation()

  const isChart = location.pathname.startsWith('/chart')
  const isPremium = location.pathname.startsWith('/premium')
  const isPayment = location.pathname.startsWith('/payment')

  return (
    <nav className={cn('navbar', { 'no-blur': isChart || isPremium || isPayment })}>
      <ul className="nav-list">
        <li className="nav-item">
          <NavLink to="/home" className="nav-link">
            <HomeIcon />
            Главная
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/chart" onClick={onChartClick} className="nav-link">
            <ChartIcon />
            График
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/profile" onClick={onUserClick} className="nav-link">
            <UserIcon />
            Аккаунт
          </NavLink>
          <StepTooltip
            step={3}
            right={-45}
            top={-85}
            width={220}
            position="top-left"
            content={
              <>
                Изменить интервалы напоминаний вы можете на странице{' '}
                <span style={{ fontWeight: 600 }}>Аккаунт</span>
              </>
            }
          />
        </li>
      </ul>
    </nav>
  )
}
